<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <OfferDocumentationForm
            @closeDialog="closeDialog"
            :view-only="viewOnly"
            :hide-button="viewOnly"
            ref="offerForm" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import OfferDocumentationForm from "@/modules/book/views/task/components/OfferDocumentationForm.vue";

export default {
  name: 'OfferDocumentationDialog',
  components: {OfferDocumentationForm},
  data() {
    return {
      dialog: false,
      viewOnly: true
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.offerForm.clearForm();
      this.viewOnly = true;
      this.$emit('closeDialog');
    },
    openCreationDialog(createData) {
      this.dialog = true;
      this.viewOnly = false;
      this.$refs.offerForm.setCreateData(createData);
    },
    openDialog(item) {
      this.dialog = true
      if (!item) {
        return;
      }

      this.viewOnly = false;
      this.$refs.offerForm.setEditData(item);
    },
    viewDialog(item) {
      this.openDialog(item);
      this.viewOnly = true;
    }
  }
}
</script>